import type { SubmissionAttemptPackageComponent } from '@/services/api/agentflowService';

interface PackageContentsSectionProps {
  packageContents: SubmissionAttemptPackageComponent[];
}

export const PackageContentsSection = ({
  packageContents,
}: PackageContentsSectionProps) => {
  const sorted = [...packageContents].sort(
    (a, b) => (a.component_order ?? 0) - (b.component_order ?? 0),
  );
  const totalPages = sorted.reduce(
    (sum, c) => sum + (c.page_count ?? 0),
    0,
  );

  return (
    <div>
      <div className="flex items-baseline justify-between mb-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-zinc-500">
          Package
        </span>
        <span className="text-xs text-zinc-500">
          {totalPages} page{totalPages !== 1 ? 's' : ''}
        </span>
      </div>
      <div className="space-y-1.5">
        {sorted.map((component, i) => (
          <div key={i} className="flex items-center gap-2 text-sm">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-green-500 shrink-0" />
            <span className="text-zinc-700 truncate flex-1">
              {component.label}
            </span>
            <span className="text-xs text-zinc-500 shrink-0">
              {component.page_count ?? '-'} page
              {(component.page_count ?? 0) !== 1 ? 's' : ''}
            </span>
            {component.signed && (
              <span className="text-[10px] font-medium text-green-600 shrink-0">
                Signed
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
